import { render, staticRenderFns } from "./AssumptionsImpactsActivePolicyDuration.vue?vue&type=template&id=6b3c397b&"
import script from "./AssumptionsImpactsActivePolicyDuration.vue?vue&type=script&lang=js&"
export * from "./AssumptionsImpactsActivePolicyDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports